// extracted by mini-css-extract-plugin
module.exports = {"title":"bHSby7","text":"_3OzI6g","image":"CyntXC","planItems":"_2_BLft","actions":"_2aDLBk","button":"_2t_2Na","planItem":"SG3zW5","shine-lines":"_2vjo4K"};